export default class Header {
    constructor($el) {
        this.$el = $el;
        this.$menu = $el.querySelector('[data-header-menu]');
        this.$toggle = $el.querySelector('[data-header-menu-toggle]');
        this.$close = $el.querySelector('[data-header-menu-close]');

        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.$toggle.addEventListener('click', this.openMenu);
        this.$close.addEventListener('click', this.closeMenu);
    }

    openMenu() {
        this.$menu.classList.add('header-menu--open');
    }

    closeMenu() {
        this.$menu.classList.remove('header-menu--open');
    }
}